export const vmImage = {
  template: `
    <img :src='fetchPicture(video.image)' :alt="alt">
  `,
  props: [
    'video',
    'alt'
  ],
  methods: {
    fetchPicture(img) {

      if(typeof img.maxrex !== 'undefined') {
        return img.maxrex.url;
      }

      if(typeof img.high !== 'undefined') {
        return img.high.url;
      }

      if(typeof img.medium !== 'undefined') {
        return img.medium.url;
      }

      if(typeof img.standard !== 'undefined') {
        return img.standard.url;
      }

      if(typeof img.default !== 'undefined') {
        return img.default.url;
      }

      return img;
    }
  }
};

export const vmImageScale = {
  template: `
    <img :src="image+'w=400&h=600&fit=crop'" class="img-fluid" alt="Watch in Any Devices">
  `,
  props: [
    'image',
  ],
};

export const vmImageBackground = {
  template: `
    <div class="qt-header-bg" data-bgimage :style="'background-image:url('+video.image+')'">
			<img :src="video.image" :alt="alt">
		</div>
  `,
  props: [
    'video',
    'alt'
  ],
};

export default {vmImage, vmImageBackground, vmImageScale};